<template>
  <div class="node-container" style="padding: 0 10px">
    <div class="marginBottom20" :style="sliderStyle">
      <el-slider v-model="currentNodeIndex" :min="1" :max="noHisList.length" show-stops :show-tooltip="false" disabled :marks="marks"></el-slider>
    </div>
    <el-popover
      popper-class="el-popover--plain"
      placement="left"
      width="300"
      :title="$t('cost.cost112')"
      trigger="hover"><!-- 完整审批流程 -->
      <el-button type="primary" round plain slot="reference" style="margin-left: 50px;">{{$t('cost.cost111')}}</el-button><!-- 查看流程信息 -->
      <div class="flex jcenter" style="padding: 20px 0; max-height: calc(100vh - 150px); overflow-y: auto">
        <el-timeline>
          <el-timeline-item hide-timestamp placement="top" v-for="(item, index) in list" :key="item.id">
            <div class="node-item">
              <el-card :class="setStyle(item).icon ? 'node-item-' + setStyle(item).icon : 'node-item-default'" :body-style="bodyStyle" :shadow="setStyle(item).shadow">
                <div class="node-name">{{ item.roleName }}</div>
                <div>{{ item.approverName }}</div>
                <div>{{ item.approveTime }}</div>
              </el-card>
              <div class="opinion">{{ item.approveOption }} </div>
            </div>
            <div class="node-sign" :class="'el-icon-' + setStyle(item).icon" slot="dot" v-if="setStyle(item).icon"></div>
          </el-timeline-item>
        </el-timeline>
      </div>
    </el-popover>
  </div>
</template>

<script>
  import { validatenull } from "@/util/validate"

  export default {
    name: "ApprovalTree",
    props: {
      list: {
        type: Array,
        default() {
          return []
        }
      },
      noHisList: {
        type: Array,
        default() {
          return []
        }
      }
    },
    data() {
      return {
        currentNodeIndex: 0,
        marks:{ },
        bodyStyle: {
          padding: '15px',
          height: '70px',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center'
        }
      }
    },
    mounted() {
      this.setNode()
      console.log(this.noHisList, 'noHisList')
    },
    methods: {
      // 设置class 和图标及card shadow状态
      setStyle(node) {
        let icon = '';
        let shadow = 'hover';
        const { agree, current } =  node;
        if (current == '00901') {
          icon = 'more';
          shadow = 'always';
        } else if (agree == '00901') {
          icon = 'success';
        } else if (agree == '00900') {
          icon = 'warning';
        }
        return  {
          icon,
          shadow
        }
      },
      /**
       * currentNodeIndex == -1 表示已经走完流程，标识到最后节点
       * 所有走完的节点都标识为红色
       */
      setNode() {
        const list = JSON.parse(JSON.stringify(this.noHisList))
        const currentNodeIndex = list.findIndex(item => item.current === '00901')
        this.currentNodeIndex = currentNodeIndex == -1 ? list.length : currentNodeIndex + 1
        const marks = {}
        list.forEach((item, index) => {
          const { agree, current } =  item
          if (currentNodeIndex === -1 || current == '00901' || agree == '00901') {
            marks[index + 1] = {
              style: {
                color: '#C73122'
              },
              label: item.roleName
            }
          } else {
            marks[index + 1] = item.roleName
          }
        })
        this.marks = marks
      }
    },
    computed: {
      sliderStyle() {
        return {
          width: `${ this.noHisList.length * 100 }px`,
          minWidth: '500px'
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  $nodeLineHeight: 30px;
  $success: #67C23A;
  $error: #f56c6c;
  $more: #FF6B07;

  .node-container {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;

    ::v-deep.el-slider__runway.disabled .el-slider__bar{
      background-color: #C73122;
    }

    ::v-deep.el-slider__runway.disabled .el-slider__button {
      border-color: #C73122;
    }

    /*::v-deep.el-slider__marks-text {*/
      /*color: #C73122;*/
    /*}*/

    ::v-deep.el-slider__marks-text:last-child {
      left: initial !important;
      right: 0;
      transform: translateX(50%);
    }
  }
  .node-item {
    width: 200px;
    border-radius: 6px;
    position: relative;
    line-height: 22px;
    cursor: pointer;
    &:last-child {
      margin-bottom: 0;
    }
    .node-item-default {
      color: #909399;
    }
    .node-item-more {
      color: $more;
    }
    .node-line {
      position: absolute;
      width: $nodeLineHeight;
      height: 3px;
      background-color: #DCDFE6;
      left: -$nodeLineHeight;
      top: 50%;
    }
    .node-name {
      font-weight: bold;
      font-size: 15px;
      line-height: 24px;
    }
  }
  .node-sign {
    font-size: 20px;
    position: absolute;
    left: -4px;
    -webkit-border-radius: 50%;
    -moz-border-radius: 50%;
    border-radius: 50%;
    &.el-icon-success {
      color: $success;
    }
    &.el-icon-warning {
      color: $error;
    }
    &.el-icon-more {
      color: #fff;
      background-color: $more;
      font-size: 15px;
      padding: 2px;
    }
  }
  .opinion {
    width: 200px;
    line-height: 20px;
    padding: 5px;
  }
</style>
